<script lang="ts" setup>
	interface Attrs {
		to?: any
		target?: '_blank' | '_new'
		noPrefetch?: boolean
		external?: boolean
	}
	const { to, scrollTo, noPrefetch = true, external, target } = defineProps<{
		label?: string|number
		icon?: any
		iconRight?: string
		avatar?: string
		collapse?: string
		stack?: boolean
		size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
		color?: string
		variant?: string
		activeVariant?: string
		to?: string|object
		scrollTo?: string
		noPrefetch?: boolean
		target?: '_blank' | '_new'
		external?: boolean
		block?: boolean
		square?: boolean

	}>()
	const self = ref()
	let attrs: Attrs = {}

	if (to !== undefined) {
		attrs.to = to
		attrs.external = external
		attrs.noPrefetch = noPrefetch
		if (target)
			attrs.target = target
	}


	if (scrollTo)
		onMounted(() => {
			useEventListener(self.value.$el, 'click', (evt) => {
				document.querySelector(scrollTo).scrollIntoView({block: "start"})
			})
		})
</script>

<template>
	<UButton
		ref="self"
		class="cursor-pointer"
		:label="label ? label.toString() : undefined"
		:icon="icon"
		:trailingIcon="iconRight"
		:size="size"
		:variant="variant"
		:active-variant="activeVariant"
		:color="color"
		:block="block"
		:square="square"
		v-bind="attrs"
	>
		<template
			v-for="(_, slotName) in $slots"
			:key="slotName"
			:slot="slotName"
			v-slot:[slotName]="slotProps"
		>
			<slot :name="slotName" v-bind="slotProps ?? {}"/>
		</template>
	</UButton>
</template>

